import * as yup from 'yup'
import { defineMessages } from 'react-intl'
import { isEmpty } from 'lodash'

const messages = defineMessages({
  required: {
    id: 'dictionary.required',
    defaultMessage: 'Required'
  }
})

const companyMessages = defineMessages({
  required: {
    id: 'seasonEvents.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const nameMessages = defineMessages({
  required: {
    id: 'seasonEvents.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'seasonEvents.form.name.max',
    defaultMessage: 'The name can be up to 255 characters'
  }
})

const segmentsMessages = defineMessages({
  required: {
    id: 'seasonEvents.form.segments.required',
    defaultMessage: 'You need to choose at least one segment'
  }
})

const typeMessages = defineMessages({
  required: {
    id: 'seasonEvents.form.type.required',
    defaultMessage: 'The type is required'
  }
})

const testCompanyIsRequired = (value: TSFixMe, isShowingCompany: TSFixMe): TSFixMe => {
  if (isShowingCompany) {
    return !isEmpty(value)
  }

  return true
}

export const schema = (intl: TSFixMe, isShowingCompany: TSFixMe): TSFixMe => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().test('is-company-required', intl.formatMessage(companyMessages.required), function (value) {
        return testCompanyIsRequired(value, isShowingCompany)
      })
    }),
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(255, intl.formatMessage(nameMessages.max)),
    segments: yup.array().min(1, intl.formatMessage(segmentsMessages.required)),
    type: yup.string().required(intl.formatMessage(typeMessages.required)),
    activePeriods: yup.array().of(
      yup.object().shape({
        startsAt: yup.string().required(intl.formatMessage(messages.required)),
        endsAt: yup.string().required(intl.formatMessage(messages.required))
      })
    )
  })
}
